import { getTableViewFromTableQuery } from "owa-mail-triage-table-utils";
import loadInitialMailTable from "owa-mail-list-actions/lib/actions/table/loadInitialMailTable";
import type { MailFolderTableQuery, TableView } from "owa-mail-list-store";
import onInitialTableLoadComplete from "./onInitialTableLoadComplete";
import { setTableViewLoadingMutator } from "./setTableViewLoadingMutator";

/**
 * Hydrates the Priority View's TableView in the background by fetching its
 * initial rows, without changing the currently selected table. Invoked while
 * the user is still in their Inbox/Focused/Other view so that the subsequent
 * enter-Priority-View click can swap to the pre-loaded TableView.
 */
export default async function prefetchPriorityTableView(tableQuery: MailFolderTableQuery): Promise<TableView> {
    const tableView = getTableViewFromTableQuery(tableQuery);
    setTableViewLoadingMutator(tableView);
    
    await loadInitialMailTable(tableView, onInitialTableLoadComplete, null);
    return tableView;
}
